module.exports = __webpack_public_path__ + "static/media/special_price.82dc492c.svg";